/**
 * THIS FILE CONTAINS CODEGEN OUTPUT. DO NOT MODIFY MANUALLY
 *
 * A schema to test behavior of schema driven tools in this repo
 */
import * as t from 'io-ts';
import * as Version_ from './unified-config/Version';
export const schemaId = 'TestConfig';
export const Uuid = t.brand(t.string, (x) => /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(x), 'Uuid');
export const DateTime = t.brand(t.string, (x) => !isNaN(new Date(x).getTime()), 'DateTime');
export const Comment = t.array(t.string);
export const Uid = Uuid;
export const TestConfig = t.intersection([
    t.type({
        uid: Uid,
        schemaVersion: Version_.Version,
    }),
    t.partial({
        date: DateTime,
        foo: t.string,
        objectType: t.string,
        siteName: t.string,
        'GROUP 1': Comment,
        soundCloud: t.partial({
            color: t.union([t.null, t.string], 'color'),
        }, 'soundCloud'),
    }),
], 'TestConfig');
export default TestConfig;
// Success
//# sourceMappingURL=TestConfig.js.map